export default __webpack_public_path__ + "static/media/matt_haas.3fbb72fe.png";